import { Layout, Select, Space, Typography } from 'antd';
import { InformationIcon } from '../Icons';
import { useSelectStore } from '@/stores';
import { useTranslation } from 'react-i18next';
import { Heading } from '../Heading';

const { Option } = Select;
const { Text } = Typography;

const OrderPerformanceByCountry = () => {
  const { t } = useTranslation();

  const { selectedValue, setSelectedValue } = useSelectStore();

  const handleChange = (value: string) => {
    setSelectedValue(value);
  };

  return (
    <Layout className='p-6 flex h-full justify-between bg-white rounded-[10px] min-h-96 shadow-card-dark'>
      <Space className='flex justify-between items-start mb-4'>
        <Heading
          trailingIcon={<InformationIcon />}
          textTooltip='test'
          title={t('order_performance')}
          level={3}
          extraClassName='mb-0'
        />
        <Select defaultValue={selectedValue} variant='borderless' onChange={handleChange}>
          <Option value='last_week'>Last Week</Option>
          <Option value='last_month'>Last Month</Option>
          <Option value='last_year'>Last Year</Option>
        </Select>
      </Space>
      <Space className='flex space-x-4 items-center my-6'>
        <Space className='flex items-center flex-col justify-start'>
          <Text>1.Baghdad (30)</Text>
          <Text>2.Al Basrah (22)</Text>
          <Text>3.Al Mawsil (15)</Text>
          <Text>4.Al Mawsil (15)</Text>
        </Space>
      </Space>
    </Layout>
  );
};

export default OrderPerformanceByCountry;
